import React, { useState } from "react";
import {
    useTranslate,
    IResourceComponentsProps,
    useDelete,
    useList,
    useNavigation, useGetIdentity,
} from "@pankod/refine-core";
import {
    DataGrid,
    useDataGrid,
    GridColumns,
    GridActionsCellItem,
    List,
    Stack,
    Avatar,
    Typography,
    Select,
    MenuItem,
    Tooltip,
    Grid, Card, Button, useAutocomplete, Autocomplete, TextField
} from "@pankod/refine-mui";
import { Edit, Close } from "@mui/icons-material";
// import { Lessons } from "../../../const/lessons"
import { Lessons } from "../../../const/lessons2"
import { IPrincipal, ISchool, ITeacher } from "interfaces";
import moment from "moment";

type ReportCardType = {
    teacher: ITeacher;
    index: number;
    onClick: (school: ISchool | null) => void;
    userType: string;

}

const ReportCard: React.FC<ReportCardType> = ({teacher, index, onClick, userType }) => {
    const [school, setSchool] = useState<ISchool | null>(null)

    const { autocompleteProps } = useAutocomplete<ISchool>({
        resource: "school"
    });
    return <Card sx={{ padding: 1 }}>
        {
            <>

                {/* <Typography variant={"subtitle1"} sx={{ margin: 0, fontWeight: "bold" }}>Checkpoint {index + 1}:</Typography> */}
                <Typography variant={"subtitle1"} sx={{ margin: 0, fontWeight: "bold" }}>{teacher.firstName} {teacher.lastName}:</Typography>

            </>
        }
        <div style={{ display: "flex", marginTop: 24, flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
            {userType == "admin" ?
                <Autocomplete
                    size="small"
                    {...autocompleteProps}
                    value={school}
                    onChange={(_, value) => {
                        setSchool(value);
                    }}
                    getOptionLabel={(item) => {
                        return item.name
                            ? item.name
                            : "";
                    }}
                    isOptionEqualToValue={(
                        option,
                        value,
                    ) =>
                        value === undefined ||
                        option.id === value.id
                    }
                    sx={{ flex: 0.7 }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            required
                        />
                    )}
                /> : <div style={{ flex: 1 }} />}
            <Button onClick={() => onClick(school)}>Generate</Button>
        </div>

    </Card>
}

export const AssignableReportList: React.FC<IResourceComponentsProps> = () => {
    const { show, create, showUrl, push } = useNavigation();
    const t = useTranslate();
    const { mutate: mutateDelete } = useDelete();
    const { data: user } = useGetIdentity();

    const [grade, setGrade] = useState("1")

    const { data: teachers } = useList<ITeacher>({
        config: {
            filters: [
             
              {
                field: "from",
                operator: "eq",
                value: "assignables",
              },
             
            ],
          },
        resource: "teacher",
      });
    return (
        <List cardProps={{
            sx: { paddingX: { xs: 2, md: 0 } }
        }}
            cardHeaderProps={{
                title: "Assignables Reports"
            }}
        >
            <div className="my-3 space-y-2">
                            <p className="text-black/70 font-bold">
                                Select Grade
                            </p>
                            <Select placeholder="Select Grade" className="h-10 w-full" value={grade} onChange={(e) => {
                                setGrade(e.target.value)
                            }}>
                                {[
                                    1, 2, 3, 4, 5, 6, 7, 8
                                ].map(g => (
                                    <MenuItem key={g} value={g} >
                                        Grade {g}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div><p>Teachers</p></div>
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                {teachers?.data.map((teacher, index) => (
                    <Grid item xs={2} sm={4} md={4} key={index}>
                        <ReportCard teacher={teacher} userType={user?.userType || "principal"} index={index} onClick={(sc) => {
                           
                                push(`${showUrl("assignablereport", teacher.id)}?grade=${grade}`)
                          

                        }} />
                    </Grid>
                ))}
            </Grid>
        </List>
    );
};